import { Movax } from './Movax';

var DLCENTER_AJAX_URL = '/stage-ajax/dlcenterhandler/' + Movax.dom.getLanguage(),
    COOKIE_NAME = 'dlcenter-client-cart',
    COOKIE_WAITING_NAME = 'dlcenter-waiting';

export class DLCenter {
  private cartItems;
  private handlerAjaxUrl: string;
  private progressPollInterval;
  private pollingFrequency:number = 2000;
  private jobid;
  private isWaiting: boolean = false;

  constructor() {

    // We need to create custom cookie for cart as the Stage cookie is http only and cannot be read by client
    var cookieStr = Movax.storage.readCookie(COOKIE_NAME);

    this.cartItems = [];

    if (cookieStr) {
      try {
        this.cartItems = JSON.parse(cookieStr);
      } catch (e) {
        console.log('DLCenter#constructor: Invalid cookie data');
      }
    }

    this.jobid = Movax.storage.readCookie(COOKIE_WAITING_NAME);

    this.handlerAjaxUrl = DLCENTER_AJAX_URL;

    if (this.jobid) {
      this.isWaiting = true;
    }
  }

  private _updateCart(cartItems) {
    this.cartItems = cartItems;

    // Only store this one for a day, so it will hopefully expire before http only cookie set by Stage
    Movax.storage.createCookie(COOKIE_NAME, JSON.stringify(this.cartItems), 1);
  }

  private _pdfProgressPoll(jobid, progressCallback) {
    var self = this,
        pdfGradualProgress = 0;


    return new Promise<any>(function(resolve, reject) {

      if(!jobid) {
        Movax.storage.deleteCookie(COOKIE_WAITING_NAME);
        clearInterval(self.progressPollInterval);
        reject();
      }

      self.progressPollInterval = setInterval(function() {

        return Movax.xhr.get(self.handlerAjaxUrl, {
          'action': 'getpdf',
          'jobid': jobid
        }).then(function(res) {

          if(!res) {
            reject();
          }

          switch(res.status) {
            case 'failed':
              Movax.storage.deleteCookie(COOKIE_WAITING_NAME);
              clearInterval(self.progressPollInterval);
              reject();
              break;
            case 'done':
              Movax.storage.deleteCookie(COOKIE_WAITING_NAME);
              clearInterval(self.progressPollInterval);
              resolve(res.retdata.url);
              break;
            case 'running':
              var progress = Math.floor(parseFloat(res.retdata.progress) * 100) || 0,
                  percentPerPoll = 0;

              if (res.retdata.phase && res.retdata.phase == 'pdf') {
                percentPerPoll = (45 / res.params.pages.length) * 8;
              }

              pdfGradualProgress += percentPerPoll;

              progressCallback(Math.min(Math.floor(0.55 * progress + pdfGradualProgress), 99));
              break;
          }
        });

      }, self.pollingFrequency);

      // Init with 0 percent
      progressCallback(0);
    });
  }

  public isInCart(item) {
    var i, l;
    for (i = 0, l = this.cartItems.length; i < l; i++){
      if(this.cartItems[i] === item) {
        return true;
      }
    }

    return false;
  }

  public getItemCount() {
    var i, l, counter = 0;

    // There might be empty additions, we don't want to count those
    for (i = 0, l = this.cartItems.length; i < l; i++) {
      if(this.cartItems[i]) {
        counter++;
      }
    }

    return counter;
  }

  /**
   * Set custom handler ajax url
   * @param {string} url
   */
  public setHandlerAjaxUrl(url:string) {
    this.handlerAjaxUrl = url;
  }

  /**
   * Remove items from cart
   * @return {Promise} updated cart
   */
  public removeItems(items) {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var itemsArray;

      // if single item as string
      if (typeof items === 'string') {
        itemsArray = [items];
      } else {
        itemsArray = items;
      }

      return Movax.xhr.get(self.handlerAjaxUrl, {
        'action': 'remove',
        'urls': itemsArray
      }).then(function (updatedCart) {
        self._updateCart(updatedCart);
        resolve(updatedCart);
      }, function (res) {
        reject(res);
      });
    });
  }

  /**
   * Add items to cart
   * @return {Promise} updated cart
   */
  public addItems(items) {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var itemsArray, i, l;

      // if single item as string
      if (typeof items === 'string') {
        itemsArray = [items];
      } else {
        itemsArray = items;
      }

      // Convert items to strings
      for(i=0, l=itemsArray.length; i<l; i++) {
        if(typeof itemsArray[i] === 'object' && itemsArray[i]) {
          itemsArray[i] = JSON.stringify(itemsArray[i]);
        }
      }

      return Movax.xhr.get(self.handlerAjaxUrl, {
        'action': 'add',
        'urls': itemsArray
      }).then(function(updatedCart) {
        self._updateCart(updatedCart);
        resolve(updatedCart);
      }, function(res) {
        reject(res);
      });
    });
  }

  /**
   * Add items to cart
   * @return {Promise} updated cart
   */
  public getCart() {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var itemsArray;

      return Movax.xhr.get(self.handlerAjaxUrl, {
        'action': 'cart',
      }).then(function(cart) {
        //self._updateCart(updatedCart);
        resolve(cart);
      }, function(res) {
        reject(res);
      });
    });
  }

  /**
   * Generate pdf
   * @param {function} progressCallback
   * @return {Promise} download link
   */
  public generatePdf(progressCallback) {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      var itemsArray;

      return Movax.xhr.get(self.handlerAjaxUrl, {
        'action': 'pdf',
      }).then(function(jobid) {

        // Store job in cookie if user refreshes, we can continue
        Movax.storage.createCookie(COOKIE_WAITING_NAME, jobid, 1);
        self._pdfProgressPoll(jobid, progressCallback).then(function(res) {
          resolve(res);
        }, function () {
          reject();
        });
      }, function(res) {
        reject(res);
      });
    });
  }

  /**
   * Continue interrupted job (if you refresh page or something)
   * @param {function} progressCallback
   * @return {Promise} download link
   */
  public continueJob(progressCallback) {
    var self = this;
    return new Promise<any>(function(resolve, reject) {
      self._pdfProgressPoll(self.jobid, progressCallback).then(function(res) {
        resolve(res);
      }, function() {
        reject();
      });
    });
  }

  public isJobInProgress() {
    return this.isWaiting;
  }

  public abortJob() {
    Movax.storage.deleteCookie(COOKIE_WAITING_NAME);
  }

  /**
   * clear cart
   * @return {Promise} cart items
   */
  public clearCart() {
    var self = this;

    return new Promise<any>(function(resolve, reject) {
      return Movax.xhr.get(self.handlerAjaxUrl, {
        'action': 'clear'
      }).then(function(items) {
        resolve(items);
      }, function(error) {
        reject();
      });
    });
  }
}
